const ENGLISH_POLICY = "Use English for all replies and greetings. Do not switch languages because a transcript or earlier message contains another language.";

// Session creation, preference updates and response overrides share this policy.
export function englishConversationInstructions(instructions: string): string {
  return instructions.endsWith(ENGLISH_POLICY)
    ? instructions
    : `${instructions}\n${ENGLISH_POLICY}`;
}
